import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class MstClassService {
  mstClass: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'mst_class/list/?';
  private DeListRecord = webapi + 'mst_class/deactivated_list/?';
  private AddRecord = webapi + 'mst_class/create';
  private EditRecord = webapi + 'mst_class/update';
  private GetRecord = webapi + 'mst_class/byid/';
  private GetRecordByName = webapi + 'mst_class/byname/';
  private GetRecordIsOpd = webapi + 'mst_class/readisopd';
  private GetRecordIsEmg = webapi + 'mst_class/readisemg';
  private DeleteRecord = webapi + 'mst_class/delete/';
  private ReActiveRecord = webapi + 'mst_class/reActive/';

  constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllDeactivatedRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.DeListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  reActiveRecordService(id: any) {
    return this.http.put(this.ReActiveRecord + id, {headers: this.headers})
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  //  Author: Mohit
  getRecordByNameService(qString: any) {
    return this.http.get(this.GetRecordByName + qString)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordIsOpd() {
    return this.http.get(this.GetRecordIsOpd)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
  getRecordIsEmg() {
    return this.http.get(this.GetRecordIsEmg)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/mst-class/mst-class.service.ts